'use client';

import { c as _c } from "react/compiler-runtime";
import { Portal } from '@common/components';
import { SvgChevronleft } from '@common/icon';
import { cn } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import root from 'react-shadow';
import { TERM_CATEGORY, UnauthQueryOptions } from '@/api';
import { ButtonFooter } from '@/components/server';
import { useModalClosing } from '@/hooks/useModalClosing';
import { jejuYouthDreamQueryOptions } from '@/query-factory/jeju-youthdream';
interface KosafTermProps {
  opened?: boolean;
  onClose: VoidFunction;
  termType?: 'privacy_agreement' | 'consulting_agreement' | 'collection_agreement' | 'provide_agreement';
  onConfirmationClick: VoidFunction;
}
export const JejuTerm = t0 => {
  const $ = _c(19);
  const {
    opened: t1,
    onClose,
    termType: t2,
    onConfirmationClick
  } = t0;
  const opened = t1 === undefined ? false : t1;
  const termType = t2 === undefined ? "privacy_agreement" : t2;
  let t3;
  if ($[0] !== opened) {
    t3 = {
      opened,
      closingDuration: 200
    };
    $[0] = opened;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const openingTransition = useModalClosing(t3);
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = jejuYouthDreamQueryOptions.termList();
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const termList = useQuery(t4);
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/term/{termCategory}"]({
        path: {
          termCategory: TERM_CATEGORY.JEJU_PROVIDE_PRIVACY_SELECT
        }
      })
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const term = useQuery(t5);
  let t6;
  bb0: switch (termType) {
    case "provide_agreement":
      {
        t6 = "\uAC1C\uC778\uC815\uBCF4 \uC81C3\uC790 \uC81C\uACF5 \uB3D9\uC758 (\uC81C\uC8FC\uCCAD\uB144\uC13C\uD130)";
        break bb0;
      }
    case "privacy_agreement":
      {
        t6 = "\uAC1C\uC778\uC815\uBCF4\uCC98\uB9AC\uBC29\uCE68 \uB3D9\uC758";
        break bb0;
      }
    case "consulting_agreement":
      {
        t6 = "\uCCAD\uB144\uC774\uC5B4\uB4DC\uB9BC \uD504\uB85C\uADF8\uB7A8 \uCC38\uC5EC \uB3D9\uC758";
        break bb0;
      }
    case "collection_agreement":
      {
        t6 = "\uC0C1\uB2F4\uB179\uD654 \uBC0F \uBBFC\uAC10\uC815\uBCF4 \uC218\uC9D1\xB7\uC774\uC6A9\uC5D0 \uB300\uD55C \uB3D9\uC758";
        break bb0;
      }
    default:
      {
        t6 = "\uAC1C\uC778\uC815\uBCF4\uCC98\uB9AC\uBC29\uCE68 \uB3D9\uC758";
      }
  }
  const title = t6;
  let t7;
  if ($[4] !== onClose || $[5] !== onConfirmationClick) {
    t7 = () => {
      onClose();
      onConfirmationClick();
    };
    $[4] = onClose;
    $[5] = onConfirmationClick;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const handleAgreeClick = t7;
  let t8;
  if ($[7] !== term || $[8] !== termList || $[9] !== termType) {
    t8 = termType === "provide_agreement" ? term.data?.context?.contents || "" : termList.data?.find(term_0 => term_0.termsId === termType)?.termsContent || "";
    $[7] = term;
    $[8] = termList;
    $[9] = termType;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = {
      __html: t8
    };
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const contentsHtml = t9;
  let t10;
  if ($[13] !== contentsHtml || $[14] !== handleAgreeClick || $[15] !== onClose || $[16] !== openingTransition || $[17] !== title) {
    t10 = openingTransition ? <Portal renderTo={_temp}><div className="fixed left-0 top-0 z-[51] flex size-full items-end justify-center"><div className="relative flex size-full max-w-root items-end justify-end"><article className={cn("[&>section]:p-24 [&>section]:px-20", "fixed z-[51] flex size-full max-h-screen min-h-screen flex-col bg-Gray-white")}><nav className="box-border grid min-h-56 grid-cols-2 items-center bg-Gray-white px-10 text-center"><div className="flex"><button aria-label={"\uB4A4\uB85C \uAC00\uAE30"} className="relative size-48 flex-center" type="button" onClick={onClose}><SvgChevronleft className="size-24" /></button></div><h3 className="font-semibold absolute left-1/2 flex w-auto -translate-x-1/2 items-center justify-center break-keep text-center text-[1rem] text-Gray-900">{title}</h3></nav><root.section className="overflow-auto" title={title}><div className="z-[51] size-full border-none" dangerouslySetInnerHTML={contentsHtml} /></root.section><ButtonFooter onClick={handleAgreeClick}>동의</ButtonFooter></article></div></div></Portal> : <></>;
    $[13] = contentsHtml;
    $[14] = handleAgreeClick;
    $[15] = onClose;
    $[16] = openingTransition;
    $[17] = title;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
function _temp() {
  return document.body;
}